import { createStyles, makeStyles, styled } from '@material-ui/core';
import { StyledDialog } from '@room-match/shared-ui-components';

export const useStyles = makeStyles((theme) =>
  createStyles({
    chipContainer: {
      '& .MuiChip-root': {
        margin: '0 5px 10px 0',
      },
    },
  }),
);

export const CustomDialog = styled(StyledDialog)({
  '&.paper': {
    minWidth: '85%',
    minHeight: '90%',
  },
  '& .MuiDialog-paperWidthSm': {
    maxWidth: 700,
  },
});
